import { syncPriceContainer } from './tc-local-variants.js?v=20261022-render-stable-1';
import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

class ProductPrice extends Component {
  #eventRoot;
  #selection = 0;

  connectedCallback() {
    super.connectedCallback();
    this.#eventRoot = this.closest('.shopify-section, dialog');
    this.#eventRoot?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.#eventRoot?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#eventRoot = undefined;
    this.#selection++;
    super.disconnectedCallback();
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const picker = event.target.closest('variant-picker');
    if (picker?.dataset.productId && this.dataset.productId &&
        String(picker.dataset.productId) !== String(this.dataset.productId)) return;
    if (!event.promise || typeof event.promise.then !== 'function') return;
    const selection = ++this.#selection;
    event.promise.then(({ detail } = {}) => {
      if (selection !== this.#selection || !this.isConnected || !detail?.html) return;
      const { html, newProduct } = detail;
      if (newProduct) {
        this.dataset.productId = String(newProduct.id);
      } else if (detail.productId && this.dataset.productId &&
                 String(detail.productId) !== String(this.dataset.productId)) {
        return;
      }
      const candidates = [...html.querySelectorAll('product-price')];
      const newProductPrice = candidates.find((node) =>
        node.dataset.blockId === this.dataset.blockId &&
        (!node.dataset.productId || !this.dataset.productId ||
          String(node.dataset.productId) === String(this.dataset.productId)));
      if (!newProductPrice) {
        console.warn('[product-price] Matching price block missing in variant response', this.dataset.blockId);
        return;
      }
      const currentPrice = this.querySelector('[ref="priceContainer"]');
      const incomingPrice = newProductPrice.querySelector('[ref="priceContainer"]');
      const insertedPrice = incomingPrice?.cloneNode(true);
      let renderedPrice = currentPrice;
      if (currentPrice && incomingPrice && !syncPriceContainer(currentPrice, incomingPrice)) {
        currentPrice.replaceWith(insertedPrice);
        renderedPrice = insertedPrice;
      }
      const currentNote = this.querySelector('[ref="volumePricingNote"]');
      const incomingNote = newProductPrice.querySelector('[ref="volumePricingNote"]');
      if (!incomingNote) currentNote?.remove();
      else if (currentNote) currentNote.replaceWith(incomingNote.cloneNode(true));
      else if (renderedPrice?.parentNode) renderedPrice.after(incomingNote.cloneNode(true));
      const installmentsInput = this.querySelector('form[id^="product-form-installment-"] input[name="id"]');
      if (installmentsInput) {
        installmentsInput.value = detail.resource?.id ?? '';
        installmentsInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }).catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[product-price] Event promise rejected:', error);
    });
  };
}
if (!customElements.get('product-price')) customElements.define('product-price', ProductPrice);
